import * as z from "zod"

export const ImageSchema = z.object({
  id: z.number().optional(),
  uuid: z.string().optional(),
  isTemporary: z.boolean(),
  name: z.string(),
  size: z.number(),
  mime_type: z.string(),
  uri: z.string(),
  thumbnail_url: z.string().optional(),
  preview_url: z.string().optional(),
  deleted: z.boolean().optional()
});

export const ALLOWED_RATINGS = ["very_poor", "poor", "fair", "good", "very_good", "no_rating"] as const;

export const LocationIdSchema = z.union([z.number(), z.string()]).nullable().optional();

export const testFormSchema = z.object({
  formId: z.string().optional().nullable(),
  assessmentId: z.number().min(1, "Inspection is required"),
  test_specification_id: z.number().min(1, "Test is required"),
  assetId: z.number().min(1, "Asset is required"),
  location: z.string().min(1, "Location is required"),
  building_id: LocationIdSchema,
  level_id: LocationIdSchema,
  area_id: LocationIdSchema,
  element: z.number().min(1, "Element is required"),
  element_id: z.string().min(1, "Element Identifier is required"),
  element_name: z.string().min(1, "Element Name is required"),
  observations: z.string().optional(),
  recommendations: z.string().optional(),
  result: z.enum(ALLOWED_RATINGS).optional(),
  status: z.enum(["archived", "draft", "qa", "published"]),
  images: z.array(ImageSchema).optional(),
  custom: z.record(z.string(), z.any()) // Use z.record for dynamic keys

})

export type TestFormValues = z.infer<typeof testFormSchema>

export type TestStatus = "archived" | "draft" | "qa" | "published"

